'use client';
import React from 'react';
import SideNavItem, {
	SideNavItemProps,
} from '../../components/SideNavItem/SideNavItem';
import { icons } from '@/Icons';
import { ModalStatusEnum, useModalStoreActions } from '@/store';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import { SectionWrapper } from '../../SideNav';
import useOpenCloseToggle from '../../hooks/useOpenCloseToggle';
import ContentWrapper from '../../components/ContentWrapper/ContentWrapper';

const OfferLinks = () => {
	const { setModalStatus } = useModalStoreActions();
	const { open, toggleOpen } = useOpenCloseToggle();

	const offersData: SideNavItemProps[] = [
		{
			title: 'Rewards',
			link: '/rewards',
			icon: <icons.rewards />,
		},
		// {
		// 	title: 'Promotions',
		// 	link: '/',
		// 	icon: <icons.promotions />,
		// },

		{
			title: 'Redeem Code',
			onClick: () => {
				setModalStatus(ModalStatusEnum.RedeemPromoModal);
			},
			authRequired: true,
			icon: <icons.redeemcode />,
		},
		{
			title: 'Referrals',
			link: '/referrals',
			icon: <icons.personshare />,
		},
	];

	return (
		<SectionWrapper>
			<SectionTitle title="Offers" toggleOpen={toggleOpen} open={open} />
			<ContentWrapper open={open}>
				{offersData.map((item, index) => {
					return <SideNavItem key={index} {...item} />;
				})}
			</ContentWrapper>
		</SectionWrapper>
	);
};

export default OfferLinks;
